import { css, SerializedStyles } from '@emotion/react';
import { colorToCssValue, SpacingValue, TextColorOption } from '../../theming';

export const BREADCRUMB_SPACING: SpacingValue = 2;

// Static styles
export const STATIC_STYLES: SerializedStyles = css`
    color: var(--bc-text-color);

    [data-breadrumb-item] {
        display: inline-flex;
        flex-wrap: wrap;
        gap: calc(var(--hc-spacing-unit) * ${BREADCRUMB_SPACING}); // gap between text and separator
    }
`;

export function useDynamicStyles(color: TextColorOption): React.CSSProperties {
    return {
        '--bc-text-color': colorToCssValue(color),
    } as React.CSSProperties;
}
